module.exports = __webpack_public_path__ + "img/feedback.708e0899.svg";